<div class="wrapper-near-you-page">
  <div class="wrapper-near-you-left">
    <div class="header-near-you-left">
      <div (click)="goBack()" class="custom-btn custom-btn--circle-outline">
        <img src="../../../assets/icons/icon-arrow-left.svg" alt="">
      </div>
      <span *ngIf="!areItemsSelected" class="title-near-you-left">{{isSingleItemModal ? 'Item details' :
        ('NEAR_YOU_PAGE.near_you' |
        translate)}}</span>
      <span *ngIf="areItemsSelected" class="title-near-you-left">{{'NEW_TEXT.items' | translate}}</span>
    </div>
    <div *ngIf="!isSingleItemModal && !areItemsSelected" class="tabs-my-content">
      <div class="tab-my-content" (click)="selectTab('near-me')" [ngClass]="{'active': tabSelected === 'near-me'}">
        <span>{{'NEW_TEXT.near_me' | translate}}</span>
      </div>
      <div class="tab-my-content" (click)="selectTab('themes')" [ngClass]="{'active': tabSelected === 'themes'}">
        <span>{{'NEAR_YOU_PAGE.themes' | translate}}</span>
      </div>
      <div class="tab-my-content" (click)="selectTab('listers')" [ngClass]="{'active': tabSelected === 'listers'}">
        <span>
          {{'NEAR_YOU_PAGE.listers' | translate}}
        </span>
      </div>
    </div>
    <div *ngIf="!isSingleItemModal" class="wrapper-content-tabs">
      <app-near-me class="wrapper-tab-near-me" *ngIf="tabSelected === 'near-me'"
        (itemSelected)="setMarkerAndModal($event)" [items]="itemsInAroundYou"
        [areItemsSelected]="areItemsSelected"></app-near-me>
      <app-themes class="wrapper-tab-themes" *ngIf="tabSelected === 'themes'" [themes]="subcategories"
        [selectedTheme]="urlParams.subcategoryId"></app-themes>
      <app-listers class="wrapper-tab-listers" *ngIf="tabSelected === 'listers'"
        [followingType]="urlParams.following"></app-listers>
    </div>
    <app-single-item-preview-modal *ngIf="isSingleItemModal" [singleItem]="selectedMarker"
      (closeModal)="isSingleItemModal = false" (confirmModal)="openGoogleMaps()"></app-single-item-preview-modal>
  </div>
  <div class="wrapper-near-you-right">
    <div class="wrapper-map-preview">
      <div #mapContainer class="map-container"></div>
    </div>
  </div>

  <app-map-legend-modal *ngIf="isMapLegendModalShow" (closeModal)="isMapLegendModalShow = false"></app-map-legend-modal>
</div>
